// Import Core
import React, { useState, useEffect, useRef } from "react";
import styled from "styled-components";
// Import Libraries
import ReactPlayer from "react-player";
// Import Components
import IconButton from "./buttons/IconButton";
// Import Assets
import { FaPause, FaPlay } from "react-icons/fa";
import { MdFullscreen } from "react-icons/md";

const VideoStyling = styled.div`
  position: relative;
  display: block;
  width: 100%;
  overflow: hidden;
  .video {
    max-width: inherit;
    width: 100% !important;
    height: 100% !important;
    position: relative;
    display: block;
    overflow: hidden;
    &::before {
      display: block;
      content: "";
      padding-top: 56.25%;
    }
    iframe {
      position: absolute;
      top: 0;
      bottom: 0;
      left: 0;
      width: 100%;
      height: 100%;
      border: 0;
    }
  }
  .video-controls {
    position: absolute;
    bottom: 0;
    left: 1px;
    width: 100%;
    ${"" /* height: 80px; */}
    display: flex;
    justify-content: space-between;
    align-items: center;
    z-index: 1;
    background: linear-gradient(
      180deg,
      rgba(0, 0, 0, 0) 0%,
      rgba(0, 0, 0, 0.8) 100%
    );
    @media (max-width: 768px) {
      height: 60px;
    }
    .left {
      display: flex;
      align-items: center;
      gap: 20px;
    }
    .right {
      align-self: stretch;

      .fullscreen {
        height: 100%;

        svg {
          padding: 10px;
        }
      }
    }

    .playPauseButton,
    .fullscreen {
      height: 80px;
      width: 80px;
      background: rgba(0, 0, 0, 0.6);
      display: flex;
      justify-content: center;
      align-items: center;
      @media (max-width: 768px) {
        height: 60px;
        width: 60px;
      }
      svg {
        padding: 16px;
        background-color: transparent;
      }
    }
    .video-copy {
      color: var(--white);
      transition: opacity 0.3s ease, display 0.3s ease allow-discrete;

      &.fade {
        opacity: 0;
        display: none;
      }
    }
  }
`;

const Video = ({ video, className }) => {
  // console.log("🚀 ~ file: Video.js:80 ~ Video ~ video:", video);

  const [isPlaying, setIsPlaying] = useState(false);
  const [hasWindow, setHasWindow] = useState(false);
  const videoRef = useRef(null);

  useEffect(() => {
    if (typeof window !== "undefined") {
      setHasWindow(true);
    } else {
      setHasWindow(false);
    }
  }, []);

  const togglePlay = () => {
    // console.log('play / pause');
    setIsPlaying((prev) => !prev);
  };

  const handleFullscreen = () => {
    videoRef.current.requestFullscreen();
  };

  return (
    <VideoStyling className={`video-block${className ? ` ${className}` : ""}`}>
      {hasWindow && (
        <div ref={videoRef}>
          <ReactPlayer
            url={`https://player.vimeo.com/video/${video.videoURL}`}
            playing={isPlaying ? true : false}
            controls={false}
            muted={false}
            // light={true}
            className="video"
          />
        </div>
      )}

      <div className="video-controls">
        <div className="left">
          <IconButton
            className="playPauseButton"
            clickHandler={togglePlay}
            isDisabled={false}
          >
            {isPlaying ? <FaPause /> : <FaPlay />}
          </IconButton>
          <div className={`video-copy ${isPlaying ? "fade" : ""}`}>
            <h3 className="alt video-caption small">{video.videoTitle}</h3>
            {video.videoDescription && (
              <p className="video-description">{video.videoDescription}</p>
            )}
          </div>
        </div>
        <div className="right">
          <IconButton
            className="fullscreen"
            clickHandler={handleFullscreen}
            isDisabled={false}
          >
            <MdFullscreen />
          </IconButton>
        </div>
      </div>
    </VideoStyling>
  );
};

export default Video;
